import Reveal from "../components/Reveal";
import { Link } from "react-router-dom";
import { JOURNEY_STEPS, IMG } from "../data/content";

export default function Journey() {
  return (
    <section id="journey" data-testid="journey-section" className="relative scroll-mt-20 overflow-hidden py-24 sm:py-32 lg:py-40">
      <img
        src={IMG.misty}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.08]"
      />
      <div className="relative mx-auto max-w-4xl px-6 sm:px-12">
        <Reveal>
          <p className="text-center text-xs font-medium uppercase tracking-[0.3em] text-brass">The Journey</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 text-center font-serif text-3xl font-light leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
            <Link data-testid="home-journey-page-link" to="/journey" className="text-inherit no-underline">
              The road ends.
              <br />
              <span className="italic text-brass">The journey begins.</span>
            </Link>
          </h2>
        </Reveal>

        <div className="relative mx-auto mt-20 max-w-xl">
          <div className="absolute left-4 top-0 h-full w-px bg-gradient-to-b from-brass/60 via-brass/25 to-brass/60 sm:left-1/2" aria-hidden="true" />
          {JOURNEY_STEPS.map((step, i) => (
            <Reveal key={step.name} delay={0.05 * i}>
              <div
                data-testid={`journey-step-${i}`}
                className={`relative mb-14 pl-14 last:mb-0 sm:w-1/2 sm:pl-0 ${
                  i % 2 === 0
                    ? "sm:pr-14 sm:text-right"
                    : "sm:ml-auto sm:pl-14"
                }`}
              >
                <span
                  className={`absolute top-1.5 h-2.5 w-2.5 rounded-full border border-brass bg-charcoal left-[11px] ${
                    i % 2 === 0 ? "sm:-right-[5px] sm:left-auto" : "sm:-left-[5px]"
                  }`}
                  aria-hidden="true"
                />
                <h3 className="font-serif text-2xl font-light tracking-wide text-ivory sm:text-3xl">
                  {step.name}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ivory/55">{step.note}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mx-auto mt-16 max-w-lg text-center text-sm leading-relaxed text-ivory/55">
            Reaching Bhasedi: by road from Ramnagar, by train to Ramnagar station, or by air
            to Pantnagar — then the forest takes over.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
